import React from 'react';

import LiveClassesList from '@magoosh/pages/live_classes/organisms/live_classes_list';
import Icon from '@magoosh/pages/live_classes/assets/icons';
import style from '@magoosh/pages/live_classes/style.module.scss';
import { pluralize } from 'utilities/pluralize';
import { useYourClassesContext } from '@magoosh/pages/live_classes/all_classes/context';
import { DateBox } from '@magoosh/pages/live_classes/lib/DateBox';
import moment from 'moment';

export const YourClasses: React.FC = () => {
  const { data, fetchData } = useYourClassesContext();

  React.useEffect(() => {
    fetchData('upcoming');
  }, []);

  return (
    <>
      <LiveClassesList
        icon={<DateBox moment={moment()} variant="secondary" />}
        title="Live Classes This Week"
        description={pluralize(data.upcoming.thisWeek.length, 'Class', 'Classes')}
        liveClasses={data.upcoming.thisWeek}
      />

      <LiveClassesList
        icon={<DateBox moment={moment().day(8)} variant="secondary" />}
        title="Live Classes Next Week"
        description={pluralize(data.upcoming.nextWeek.length, 'Class', 'Classes')}
        liveClasses={data.upcoming.nextWeek}
      />
      <LiveClassesList
        icon={<Icon iconType="DateTime" fill={style.brandSecondary} />}
        title="All Future Live Classes"
        description={pluralize(data.upcoming.allFuture.length, 'Class', 'Classes')}
        liveClasses={data.upcoming.allFuture}
      />
    </>
  );
};

export default YourClasses;
